
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders, HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IsString } from 'class-validator';
import { NgxIndexedDBService } from 'ngx-indexed-db';

import * as CryptoJS from 'crypto-js';





@Injectable({
	providedIn: 'root'
})
export class GatewayService {
 
  url = environment.apiUrl;
  encryptSecretKey: string = "!data1998@#0007653@&^%(!gen4keypass";
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isHome$: BehaviorSubject<boolean> = new BehaviorSubject(true);
	constructor(private http: HttpClient, private dbService: NgxIndexedDBService) {
 
  }

	getAll(type: string): Observable<any[]> {


        //console.log("Reaching Get All ", type);
        // const httpOptions = {
        //     headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        //     type: type
        // };
      
        // let params = new HttpParams();
        // params = params.append('type', type);

        // //console.log("Http Options ", httpOptions);


        console.log("Testing SSO ");
         
		return this.http.get<any[]>(this.url + 'gateway?type=' + type  );
  }

  

  getAllIdentityUser(type: string): Observable<any[]> {

    return this.http.get<any[]>(this.url + 'gateway/IdentityUser?type=' + type  );
  }

  getAllWithSummary(type: string, staffId: string): Observable<any[]> {

      return this.http.get<any[]>(this.url + 'gateway/getallwithsummary?type=' + type + '&&staffId=' + staffId  );
   }


   
getAllWithSummaryUpdated(type: string, staffId: string, dataFields: any): Observable<any[]> {

    return this.http.post<any[]>(this.url + 'gateway/getAllWithSummaryUpdated?type=' + type + '&&staffId=' + staffId,[dataFields]  );
 }

  getAllProgramsDamageAssessmentDetails(type:string, staffId: string, take: number, skip: number,status: string,programId: string): Observable<any[]> {
    
    return this.http.post<any[]>(this.url + 'gateway/getAllProgramsDamageAssessmentDetails?type=' + type + '&&staffId=' + staffId + '&&take=' + take + '&&skip=' + skip + '&&status=' + status + '&&programId=' + programId ,[] );
  }

  PipelineLicenceReport(type:string): Observable<any[]> {

    console.log("Reaching Licence Report Service");
    
    return this.http.post<any[]>(this.url + 'gateway/PipelineLicenceReport?type=' + type ,[] );
  }


  

  getDamageAssessmentDetailsByStatus(type:string, staffId: string, take: number, skip: number,status: string): Observable<any[]> {
    
    return this.http.post<any[]>(this.url + 'gateway/getDamageAssessmentDetailsByStatus?type=' + type + '&&staffId=' + staffId + '&&take=' + take + '&&skip=' + skip + '&&status=' + status ,[] );
  }

  genericAllProgramsDamageAssessmentDetails(type:string, staffId: string, take: number, skip: number,status: string,dataFields: any): Observable<any[]> {
    
    console.log("Data passed in App Service ", dataFields);
    return this.http.post<any[]>(this.url + 'gateway/genericAllProgramsDamageAssessmentDetails?type=' + type + '&&staffId=' + staffId + '&&take=' + take + '&&skip=' + skip + '&&status=' + status + '&&dataFields=' + '' ,[dataFields] );
  }


  GetAllGenericSummaryUpdated(type:string, staffId: string, take: number, skip: number,status: string,dataFields: any): Observable<any[]> {
    
    console.log("Data passed in App Service ", dataFields);
    return this.http.post<any[]>(this.url + 'gateway/GetAllGenericSummaryUpdated?type=' + type + '&&staffId=' + staffId + '&&take=' + take + '&&skip=' + skip + '&&status=' + status + '&&dataFields=' + '' ,[dataFields] );
  }


  GetAllGenericDetailsUpdated(type:string, staffId: string, take: number, skip: number,status: string,dataFields: any): Observable<any[]> {
    
    console.log("Data passed in App Service ", dataFields);
    return this.http.post<any[]>(this.url + 'gateway/GetAllGenericDetailsUpdated?type=' + type + '&&staffId=' + staffId + '&&take=' + take + '&&skip=' + skip + '&&status=' + status + '&&dataFields=' + '' ,[dataFields] );
  }


  cancelLicencerequest(type:string, requests: any[]): Observable<any[]> {
    
    console.log("Data passed in App Service ", requests);
    return this.http.post<any[]>(this.url + 'gateway/cancelLicencerequest?type=' + type ,requests );
  }


	createData(type: string,data: any[]): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
         
		return this.http.post<any[]>(this.url + 'gateway/createdata?type=' + type  , data);
  }


  addOffLineData (type: string, data: any, transactionno: string, transdate: Date ) 
  {
   

    return this.dbService
    .add('tbl', {
      name: this.encryptData(data),
      batchNo: transactionno,
      transdate: transdate,
      transtype: type,
    })
  
  }

     getOfflineData(type: string){

      return this.dbService.getAllByIndex('tbl', 'transtype', IDBKeyRange.only(type))
    }

    decryptAllData(data: any[]) : any[] {

      let decryptedData = [];

      if(data.length > 0)
      {
        for(let dat of data)
        {
          decryptedData.push(this.decryptData(dat["name"]));
        }
      }
      

     

        return decryptedData;

    }
  addOneFriend() {
    this.dbService
  .add('people', {
    name: this.encryptData({
    name: `Nsisong Nuka`,
    email: `nukstel@yahoo.com`,
  }),
    email: `nukstel@yahoo.com`,
    transdate: new Date
  })
  .subscribe((key) => {
    //console.log('key: ', key);
  });


  // Update 

  // this.dbService
  // .update('people', {
  //   id: 1,
  //   email: 'luke@skywalker.com',
  //   name: 'Luke Skywalker',
  // })
  // .subscribe((storeData) => {
  //   //console.log('storeData: ', storeData);
  // });


  // this.dbService.getByKey('people', 1).subscribe((people) => {
  //   //console.log(people);
  // });

  // this.dbService.getAll('people').subscribe((peoples) => {
  //   //console.log(peoples);
  // });

  // QueryParameter

  // this.dbService.getByIndex('people', 'name', 'Dave').subscribe((people) => {
  //   //console.log(people);
  // });

  // Count
  // this.dbService.count('people').subscribe((peopleCount) => {
  //   //console.log(peopleCount);
  // });

  // Delete

  // this.dbService.delete('people', 3).subscribe((allPeople) => {
  //   //console.log('all people:', allPeople);
  // });


}



encryptData(data) {

  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
  } catch (e) {
    //console.log(e);
  }
}

decryptData(data) {

  try {
    const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
    if (bytes.toString()) {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return data;
  } catch (e) {
    //console.log(e);
  }
}
  
  
	createDataBatch(data: any[]): Observable<any[]> {
    const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
    return this.http.post<any[]>(this.url + 'gateway/createdatabatch', data);
  }
	getSingleData(type: string,id: string): Observable<any> {

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
        //   let params = new HttpParams();
        //   params = params.append('type', type);
		return this.http.get(this.url + 'gateway?type=' + type  + id,httpOptions);
	}

	updateData(type: string,data: any[], deletedData: any[]): Observable<any[]> {
     //console.log("Reaching Update function ", type);
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
        //   let params = new HttpParams();
        //   params = params.append('type', type);

        let newDataStruct = { data: data, deletedData: deletedData}

		return this.http.post<any[]>(this.url + 'gateway/update?type=' + type , newDataStruct);
  }
  

  updateDataBatch(data: any[], deletedData: any[]): Observable<any[]> {
    //console.log("Reaching Update function ", data);
       const httpOptions = {
           headers: new HttpHeaders({ 'Content-Type': 'application/json' })
           };
     
       //   let params = new HttpParams();
       //   params = params.append('type', type);

       let newDataStruct = { data: data, deletedData: deletedData}

   return this.http.post<any[]>(this.url + 'gateway/batchupdate'  , data);
 }

	deleteData2(type:string,ids: any) {
    console.log("Reaching App Delete Service", ids );
    const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			body: ids
		};

		let params = new HttpParams();
    params = params.append('stakeholderRef', ids.join(', '));
    
   
		return this.http.delete(this.url  + 'gateway?type=' + type , httpOptions);
    }

    deleteData(type:string,ids: any): Observable<any[]> {
      //console.log("Reaching Update function ", data);
         const httpOptions = {
             headers: new HttpHeaders({ 'Content-Type': 'application/json' })
             };
       
         //   let params = new HttpParams();
         //   params = params.append('type', type);
  
        // let newDataStruct = { data: data, deletedData: deletedData}
  
     return this.http.post<any[]>(this.url + 'gateway/deleteDataRefPost?type=' + type  , ids);
   }
    

    public uploadFile(file: File,data: any[], type: string): Observable<HttpEvent<{}>> {

     
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('Body', JSON.stringify(data));

       

      //console.log("Reaching Service for Upload", file);
        
        const options = {
          reportProgress: true
        };

       
        
        const req = new HttpRequest(
          'POST',
          `${this.url  + 'gateway/createdocument?type=' + type}`,
          formData,
          options
        );

        //console.log("Http Request ", req);
       return this.http.request(req);


    //   const formData2 = new FormData();
    // formData2.append('file', file);

    // return  this.http.post<any>(this.url  + 'epimsgates/createdocument?type=' + type, formData, {
    //   reportProgress: true,
    //   observe: 'events'
    // });



    //   this.http.get<any>(this.url  + 'epimsgates?type=Document').subscribe((data) => {
    //     //console.log("Data from Document Table ", data);
    //   })

        
    //     return this.http.post<any>(this.url  + 'epimsgates/createdocument?type=' + type, data, {
    //       reportProgress: true,
    //       observe: 'events'
    //     })

        
      }


      public incidentBatchDataWithFile(files: File[],data: any[]): Observable<HttpEvent<{}>> {

     
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
         // formData.append(files[i].name, files[i]);

          formData.append('file', files[i], files[i].name);
        }
       // formData.append('file', file, file.name);
        formData.append('Body', JSON.stringify(data));

       

      //console.log("Reaching Service for Upload", file);
        
        const options = {
          reportProgress: true
        };

       
        
        const req = new HttpRequest(
          'POST',
          `${this.url  + 'gateway/IncidentCreateBatchData'}`,
          formData,
          options
        );

        //console.log("Http Request ", req);
       return this.http.request(req);


   

        
      }

      genericFilter(type: string, entryType: string, searchField: any): Observable<any[]> {
        //console.log("Reaching genericFilter function ", type);
           const httpOptions = {
               headers: new HttpHeaders({ 'Content-Type': 'application/json' })
               };
    
           //   let params = new HttpParams();
           //   params = params.append('type', type);
    
           const newDataStruct = { entryType: entryType, searchField: searchField}
    
       return this.http.post<any[]>(this.url + 'gateway/search?type=' + type , newDataStruct);
     }


     getUserByEmail(type: string, email: string): Observable<any[]> {
      //console.log("Reaching genericFilter function ", type);
         const httpOptions = {
             headers: new HttpHeaders({ 'Content-Type': 'application/json' })
             };
  
         //   let params = new HttpParams();
         //   params = params.append('type', type);
  
         const newDataStruct = { email: email}
  
     return this.http.post<any[]>(this.url + 'gateway/getUserByEmail?type=' + type , newDataStruct);
   }

   getUserById(type: string, email: string): Observable<any[]> {
    //console.log("Reaching genericFilter function ", type);
       const httpOptions = {
           headers: new HttpHeaders({ 'Content-Type': 'application/json' })
           };

       //   let params = new HttpParams();
       //   params = params.append('type', type);

       const newDataStruct = { Id: email}

   return this.http.post<any[]>(this.url + 'gateway/getUserById?type=' + type , newDataStruct);
 }


   


     
	sendMail(): Observable<any[]> {
      //console.log("Reaching Mail Sending in Gateway Service");
       return this.http.get<any>(this.url + 'mailer'  );
  }

  sendPipelineLicenceMail(data: any): Observable<any> {
   //console.log("Reaching Send Pipeline Mail ");
       const httpOptions = {
           headers: new HttpHeaders({ 'Content-Type': 'application/json' })
           };

   return this.http.post<any>(this.url + 'mailer/sendpipelinelicencemail' , data);
 }

 sendManageAccountMail(data: any): Observable<any> {
  //console.log("Reaching Send Pipeline Mail ");
      const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          };

  return this.http.post<any>(this.url + 'mailer/manageaccountmail' , data);
}

sendSeismicNoticeMail(data: any): Observable<any> {
  //console.log("Reaching Send Pipeline Mail ");
      const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          };

  return this.http.post<any>(this.url + 'mailer/seismicnoticeemail' , data);
}

sendSeismicDeleteNoticeMail(data: any): Observable<any> {
  //console.log("Reaching Send Pipeline Mail ");
      const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          };

  return this.http.post<any>(this.url + 'mailer/seismicdeletenoticeemail' , data);
}

getAllGeneric(
  type: string,
  dataObject: any,take: number, skip: number
): Observable<any[]> {
 
  const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };


  // if(typeof dataObject === 'string'){

  //   dataObject = {querydata: dataObject};

  // }

  console.log('Reaching Get All Generic ', type,dataObject);
  return this.http.post<any[]>(
    this.url + 'gateway/getallgeneric?type=' + type + '&&take=' + take + '&&skip=' + skip ,
    dataObject
  );
}


getAllGenericAnonymous(
  type: string,
  dataObject: any,take: number, skip: number
): Observable<any[]> {
 
  const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };


  // if(typeof dataObject === 'string'){

  //   dataObject = {querydata: dataObject};

  // }

  console.log('Reaching Get All Generic Anonymous ', type,dataObject);
  return this.http.post<any[]>(
    this.url + 'gateway/getallgenericanonymous?type=' + type + '&&take=' + take + '&&skip=' + skip ,
    dataObject
  );
}






getAllGenericWithTransformation(
  type: string,
  dataObject: any
): Observable<any[]> {
  console.log('Reaching Get All Generic ', type);
  const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };


  return this.http.post<any[]>(
    this.url + 'gateway/getallgenericwithtransformation?type=' + type ,
    dataObject
  );
}



pipelineDataMigration( requests: any): Observable<any[]> {
    
  console.log("Data passed in App Service ", requests);
  return this.http.post<any[]>(this.url + 'gateway/pipelineDataMigration',[requests] );
}






 
}
